module.exports = __webpack_public_path__ + "img/Klimabeitrag_mit_ConClimate-Logo.ad7177e2.png";